// proto/v2/node/node.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file node/node.proto (package lvdr.v2.node, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file node/node.proto.
 */
export const file_node_node: GenFile = /*@__PURE__*/
  fileDesc("Cg9ub2RlL25vZGUucHJvdG8SDGx2ZHIudjIubm9kZSI2Cg5HZXROb2RlUmVxdWVzdBITCgtyZXNlYXJjaF9pZBgBIAEoCRIPCgdub2RlX2lkGAIgASgJIlIKEkdldE5vZGVUcmVlUmVxdWVzdBITCgtyZXNlYXJjaF9pZBgBIAEoCRIUCgxyb290X25vZGVfaWQYAiABKAkSEQoJbWF4X2RlcHRoGAMgASgFIiwKFVN1YnNjcmliZU5vZGVzUmVxdWVzdBITCgtyZXNlYXJjaF9pZBgBIAEoCSIuChdVbnN1YnNjcmliZU5vZGVzUmVxdWVzdBITCgtyZXNlYXJjaF9pZBgBIAEoCSIwCgxOb2RlUmVzcG9uc2USIAoEbm9kZRgBIAEoCzISLmx2ZHIudjIubm9kZS5Ob2RlIkoKEE5vZGVUcmVlUmVzcG9uc2USEwoLcmVzZWFyY2hfaWQYASABKAkSIQoFbm9kZXMYAiADKAsyEi5sdmRyLnYyLm5vZGUuTm9kZSJICg9Ob2RlVXBkYXRlRXZlbnQSEwoLcmVzZWFyY2hfaWQYASABKAkSIAoEbm9kZRgCIAEoCzISLmx2ZHIudjIubm9kZS5Ob2RlIpoBChZOb2RlU3RhdHVzQ2hhbmdlZEV2ZW50EhMKC3Jlc2VhcmNoX2lkGAEgASgJEg8KB25vZGVfaWQYAiABKAkSFwoPcHJldmlvdXNfc3RhdHVzGAMgASgJEhIKCm5ld19zdGF0dXMYBCABKAkSLQoJdGltZXN0YW1wGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKEAQoNTm9kZVJlZGFjdGlvbhINCgVzdGFydBgBIAEoBRILCgNlbmQYAiABKAUSGAoQc2Vuc2l0aXZpdHlfdHlwZRgDIAEoCRIaChJjbGVhcmFuY2VfcmVxdWlyZWQYBCABKAUSDAoEbW9kZRgFIAEoCRITCgtyZXBsYWNlbWVudBgGIAEoCSLnBAoETm9kZRIPCgdub2RlX2lkGAEgASgJEhMKC3Jlc2VhcmNoX2lkGAIgASgJEhEKCXBhcmVudF9pZBgDIAEoCRIMCgRnb2FsGAQgASgJEg4KBnN0YXR1cxgFIAEoCRISCgphZ2VudF90eXBlGAYgASgJEg4KBm91dHB1dBgHIAEoCRINCgVkZXB0aBgIIAEoBRIRCgljaGlsZF9pZHMYCSADKAkSLgoKY3JlYXRlZF9hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgLIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEQoJdG9rZW5zX2luGAwgASgFEhIKCnRva2Vuc19vdXQYDSABKAUSEAoIc2VxdWVuY2UYDiABKAUSLwoKcmVkYWN0aW9ucxgUIAMoCzIbLmx2ZHIudjIubm9kZS5Ob2RlUmVkYWN0aW9uEhMKC2Z1bGxfYWNjZXNzGBUgASgIEg0KBWlucHV0GBYgASgJEhUKDXF1YWxpdHlfc2NvcmUYFyABKAESFgoOY2l0YXRpb25fY291bnQYGCABKAUSFQoNZXJyb3JfbWVzc2FnZRgZIAEoCRIyCghtZXRhZGF0YRgaIAMoCzIgLmx2ZHIudjIubm9kZS5Ob2RlLk1ldGFkYXRhRW50cnkSEAoIZGVncmFkZWQYGyABKAgSFwoPZGVncmFkZWRfcmVhc29uGBwgASgJGi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUIlWiNnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvbm9kZWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.node.GetNodeRequest
 */
export type GetNodeRequest = Message<"lvdr.v2.node.GetNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.node.GetNodeRequest.
 * Use `create(GetNodeRequestSchema)` to create a new message.
 */
export const GetNodeRequestSchema: GenMessage<GetNodeRequest> = /*@__PURE__*/
  messageDesc(file_node_node, 0);

/**
 * @generated from message lvdr.v2.node.GetNodeTreeRequest
 */
export type GetNodeTreeRequest = Message<"lvdr.v2.node.GetNodeTreeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string root_node_id = 2;
   */
  rootNodeId: string;

  /**
   * @generated from field: int32 max_depth = 3;
   */
  maxDepth: number;
};

/**
 * Describes the message lvdr.v2.node.GetNodeTreeRequest.
 * Use `create(GetNodeTreeRequestSchema)` to create a new message.
 */
export const GetNodeTreeRequestSchema: GenMessage<GetNodeTreeRequest> = /*@__PURE__*/
  messageDesc(file_node_node, 1);

/**
 * @generated from message lvdr.v2.node.SubscribeNodesRequest
 */
export type SubscribeNodesRequest = Message<"lvdr.v2.node.SubscribeNodesRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.node.SubscribeNodesRequest.
 * Use `create(SubscribeNodesRequestSchema)` to create a new message.
 */
export const SubscribeNodesRequestSchema: GenMessage<SubscribeNodesRequest> = /*@__PURE__*/
  messageDesc(file_node_node, 2);

/**
 * @generated from message lvdr.v2.node.UnsubscribeNodesRequest
 */
export type UnsubscribeNodesRequest = Message<"lvdr.v2.node.UnsubscribeNodesRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.node.UnsubscribeNodesRequest.
 * Use `create(UnsubscribeNodesRequestSchema)` to create a new message.
 */
export const UnsubscribeNodesRequestSchema: GenMessage<UnsubscribeNodesRequest> = /*@__PURE__*/
  messageDesc(file_node_node, 3);

/**
 * Responses
 *
 * @generated from message lvdr.v2.node.NodeResponse
 */
export type NodeResponse = Message<"lvdr.v2.node.NodeResponse"> & {
  /**
   * @generated from field: lvdr.v2.node.Node node = 1;
   */
  node?: Node | undefined;
};

/**
 * Describes the message lvdr.v2.node.NodeResponse.
 * Use `create(NodeResponseSchema)` to create a new message.
 */
export const NodeResponseSchema: GenMessage<NodeResponse> = /*@__PURE__*/
  messageDesc(file_node_node, 4);

/**
 * @generated from message lvdr.v2.node.NodeTreeResponse
 */
export type NodeTreeResponse = Message<"lvdr.v2.node.NodeTreeResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.node.Node nodes = 2;
   */
  nodes: Node[];
};

/**
 * Describes the message lvdr.v2.node.NodeTreeResponse.
 * Use `create(NodeTreeResponseSchema)` to create a new message.
 */
export const NodeTreeResponseSchema: GenMessage<NodeTreeResponse> = /*@__PURE__*/
  messageDesc(file_node_node, 5);

/**
 * Events
 *
 * @generated from message lvdr.v2.node.NodeUpdateEvent
 */
export type NodeUpdateEvent = Message<"lvdr.v2.node.NodeUpdateEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: lvdr.v2.node.Node node = 2;
   */
  node?: Node | undefined;
};

/**
 * Describes the message lvdr.v2.node.NodeUpdateEvent.
 * Use `create(NodeUpdateEventSchema)` to create a new message.
 */
export const NodeUpdateEventSchema: GenMessage<NodeUpdateEvent> = /*@__PURE__*/
  messageDesc(file_node_node, 6);

/**
 * @generated from message lvdr.v2.node.NodeStatusChangedEvent
 */
export type NodeStatusChangedEvent = Message<"lvdr.v2.node.NodeStatusChangedEvent"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;

  /**
   * @generated from field: string previous_status = 3;
   */
  previousStatus: string;

  /**
   * @generated from field: string new_status = 4;
   */
  newStatus: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 5;
   */
  timestamp?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.node.NodeStatusChangedEvent.
 * Use `create(NodeStatusChangedEventSchema)` to create a new message.
 */
export const NodeStatusChangedEventSchema: GenMessage<NodeStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_node_node, 7);

/**
 * NodeRedaction describes a single redacted region in node output.
 *
 * @generated from message lvdr.v2.node.NodeRedaction
 */
export type NodeRedaction = Message<"lvdr.v2.node.NodeRedaction"> & {
  /**
   * @generated from field: int32 start = 1;
   */
  start: number;

  /**
   * @generated from field: int32 end = 2;
   */
  end: number;

  /**
   * @generated from field: string sensitivity_type = 3;
   */
  sensitivityType: string;

  /**
   * @generated from field: int32 clearance_required = 4;
   */
  clearanceRequired: number;

  /**
   * "span" or "section"
   *
   * @generated from field: string mode = 5;
   */
  mode: string;

  /**
   * @generated from field: string replacement = 6;
   */
  replacement: string;
};

/**
 * Describes the message lvdr.v2.node.NodeRedaction.
 * Use `create(NodeRedactionSchema)` to create a new message.
 */
export const NodeRedactionSchema: GenMessage<NodeRedaction> = /*@__PURE__*/
  messageDesc(file_node_node, 8);

/**
 * Domain model
 *
 * @generated from message lvdr.v2.node.Node
 */
export type Node = Message<"lvdr.v2.node.Node"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * @generated from field: string research_id = 2;
   */
  researchId: string;

  /**
   * @generated from field: string parent_id = 3;
   */
  parentId: string;

  /**
   * @generated from field: string goal = 4;
   */
  goal: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string agent_type = 6;
   */
  agentType: string;

  /**
   * @generated from field: string output = 7;
   */
  output: string;

  /**
   * @generated from field: int32 depth = 8;
   */
  depth: number;

  /**
   * @generated from field: repeated string child_ids = 9;
   */
  childIds: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: int32 tokens_in = 12;
   */
  tokensIn: number;

  /**
   * @generated from field: int32 tokens_out = 13;
   */
  tokensOut: number;

  /**
   * @generated from field: int32 sequence = 14;
   */
  sequence: number;

  /**
   * @generated from field: repeated lvdr.v2.node.NodeRedaction redactions = 20;
   */
  redactions: NodeRedaction[];

  /**
   * @generated from field: bool full_access = 21;
   */
  fullAccess: boolean;

  /**
   * @generated from field: string input = 22;
   */
  input: string;

  /**
   * @generated from field: double quality_score = 23;
   */
  qualityScore: number;

  /**
   * @generated from field: int32 citation_count = 24;
   */
  citationCount: number;

  /**
   * User-friendly error reason for failed nodes
   *
   * @generated from field: string error_message = 25;
   */
  errorMessage: string;

  /**
   * Whitelisted node metadata for FE consumption. The domain Node.Metadata
   * map is internal and contains arbitrary (potentially sensitive) keys;
   * only keys that the FE has a legitimate need to display are exposed
   * here — see `metadataAllowList` in internal/node/ws_handler.go. Empty
   * when the node carries no whitelisted keys.
   *
   * @generated from field: map<string, string> metadata = 26;
   */
  metadata: { [key: string]: string };

  /**
   * FE-36: a completed node that produced nothing usable (placeholder section,
   * zero-chunk prepare, sub-floor retrieval). Derived server-side via
   * domain.DeriveNodeDegraded; the node's real `status` stays "completed".
   *
   * @generated from field: bool degraded = 27;
   */
  degraded: boolean;

  /**
   * @generated from field: string degraded_reason = 28;
   */
  degradedReason: string;
};

/**
 * Describes the message lvdr.v2.node.Node.
 * Use `create(NodeSchema)` to create a new message.
 */
export const NodeSchema: GenMessage<Node> = /*@__PURE__*/
  messageDesc(file_node_node, 9);

